import { useStorage, useWorkspace } from '@playbooks/contexts';
import { Button } from '@playbooks/ui/components/button';
import { Icon } from '@playbooks/ui/components/icon';
import { Link } from '@playbooks/ui/components/link';
import { TEMP_AUTH_COOKIE_NAME, TEMP_WORKSPACE_COOKIE_NAME } from '@playbooks/utils';

const AppBanner = () => {
	const storage = useStorage();
	const workspace = useWorkspace();
	const tempAuth = storage.getCookie(TEMP_AUTH_COOKIE_NAME);
	const securityPolicy = workspace.workspace?.securityPolicy;
	const requiresEnrollment =
		workspace.type === 'collaborative' && securityPolicy?.requireMemberMfa && !securityPolicy?.mfaEnabled;
	const enforcementStarted = requiresEnrollment && securityPolicy?.status === 'enforced';

	// Methods
	const onClick = () => {
		storage.removeCookies([TEMP_WORKSPACE_COOKIE_NAME, TEMP_AUTH_COOKIE_NAME], true);
		window.close();
	};

	// Render
	if (!tempAuth && !requiresEnrollment) return null;
	return (
		<aside className='flex-between w-full gap-3 border p-3'>
			<div className='flex-start grow gap-2'>
				<Icon icon={tempAuth ? 'user-crown' : 'shield'} className='shrink-0' aria-hidden />
				<p className='text-sm text-foreground-body'>
					{tempAuth
						? 'You are in admin mode.'
						: enforcementStarted
							? 'Two-factor authentication is required to access this workspace. Enroll to restore access.'
							: `This workspace will require two-factor authentication after ${new Date(securityPolicy.effectiveAt).toLocaleString()}.`}
				</p>
			</div>
			{tempAuth ? (
				<Button variant='link' onClick={onClick}>
					<Icon data-icon='inline-start' type='far' icon='xmark' aria-hidden />
					Exit
				</Button>
			) : (
				<Link variant='link' href='/settings/account/security'>
					Enroll now
				</Link>
			)}
		</aside>
	);
};
export { AppBanner };
